
export { CollectionName } from "/codebuild/output/src3187143283/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"